import DownloadGtmContainerComponent from '../../components/download-gtm-container';

export const DownloadTiktokGtmContainer = ({ isSetup }: { isSetup: boolean }) => {
  return <DownloadGtmContainerComponent platformName="TikTok" isSetup={isSetup} />;
};

export default DownloadTiktokGtmContainer;
